"use client";
import { LANGUAGE_NAME } from "@/config/constConf";
import { getCookieItem } from "@/lib/commonService";
import { useSearchParams } from "next/navigation";
import { useState, useEffect, useMemo } from "react";
import CustomError404 from "../../components/CustomError/404";
import { getCMSDataClient } from "../../models/cmsClient";
import {
    CommonProvider,
    FilterConditionProvider,
    PageLayoutProvider,
    UserInfoProvider,
} from "../../provider";
import getPageDataProps from "../../utils/getCMSPageDataProps";
import Header from "../../components/Header";
import { getCmsConfig, getCmsProviderData } from "../../utils/common";

export default function NotFound() {
    const [pageLayoutData, setPageLayoutData] = useState<any>();
    const [commonParams, setCommonParams] = useState<any>();
    const searchParams = useSearchParams();
    useEffect(() => {
        const siteId = self.getSiteId();
        const site = self.getSite();
        const is_cms = self.getSiteConfiguration("is_cms");
        const language = getCookieItem(LANGUAGE_NAME) ?? "en";
        setCommonParams({ siteId, site, is_cms, language });
        const pageType = searchParams.get("pageType");
        getCMSDataClient({ pageType }).then((res: any) => {
            setPageLayoutData(res);
        });
    }, [searchParams]);
    const topNotice = useMemo(() => {
        return getPageDataProps(pageLayoutData, "H5TopNotice");
    }, [pageLayoutData]);
    const H5Circle = useMemo(() => {
        return getPageDataProps(pageLayoutData, "H5Circle");
    }, [pageLayoutData]);
    const H5Notice = useMemo(() => {
        return getPageDataProps(pageLayoutData, "H5Notice");
    }, [pageLayoutData]);

    const providerData = useMemo(() => {
        return pageLayoutData
            ? getCmsProviderData(pageLayoutData.pageData)
            : [];
    }, [pageLayoutData]);

    const layoutConfig = useMemo(() => {
        return pageLayoutData ? getCmsConfig(pageLayoutData.config[0]) : {};
    }, [pageLayoutData]);

    return (
        commonParams && (
            <CommonProvider
                host={self.location.host}
                siteId={commonParams.siteId}
                site={commonParams.site}
                is_cms={commonParams.is_cms}
                lang={commonParams.language}
            >
                <UserInfoProvider>
                    <FilterConditionProvider>
                        {pageLayoutData && (
                            <PageLayoutProvider
                                pageData={providerData}
                                config={layoutConfig}
                            >
                                <Header
                                    topNotice={topNotice}
                                    page_name={"dynamic_page"}
                                    circle={H5Circle}
                                    H5Notice={H5Notice}
                                    // route-pathname是一个自定义的header属性, 在middleware.ts塞入，用于判断当前页面的路由
                                    hiddenWhenNoFixed={false} // 设置在商品详情页header在没有被fixed时会被隐藏
                                />
                                <CustomError404 />
                            </PageLayoutProvider>
                        )}
                    </FilterConditionProvider>
                </UserInfoProvider>
            </CommonProvider>
        )
    );
}
